import {LucideDroplets, LucideWind, LucideInfinity, LucideMountainSnow} from "lucide-react";

interface BenefitProps {
    icon: React.ComponentType<{ className?: string }>;
    title: string;
    description: string;
}

const benefits: BenefitProps[] = [
    {
        icon: LucideDroplets,
        title: "Werkt als het nat is",
        description: "Geen lucifers of aanstekers nodig. Maakt vuur, ook in regen, sneeuw en na onderdompeling in water.",
    },
    {
        icon: LucideWind,
        title: "Wind deert niet",
        description: "Vonken van 3.000°C ontsteken je tondel ook bij harde wind, waar een vlam allang gedoofd zou zijn.",
    },
    {
        icon: LucideInfinity,
        title: "Duizenden vonken",
        description: "Eén staaf is goed voor duizenden ontstekingen. Jarenlang betrouwbaar, zonder bijvullen.",
    },
    {
        icon: LucideMountainSnow,
        title: "Voor elk avontuur",
        description: "Survival, kamperen, bushcraft of noodpakket. Compact, licht en altijd binnen handbereik.",
    },
];

export const UsageGuide = () => {
    return (
        <section id="voordelen" className="py-24 bg-ink-950 border-t border-ink-800">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-ember-400 mb-3">
                        Waarom Fire Strike
                    </span>
                    <h2 className="font-display font-bold uppercase text-4xl lg:text-5xl text-ink-50 mb-4">
                        Vuur als alles tegen zit
                    </h2>
                    <p className="text-xl text-ink-300 max-w-3xl mx-auto">
                        Daar waar lucifers en aanstekers het laten afweten, blijft Fire Strike presteren.
                    </p>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {benefits.map(({icon: Icon, title, description}) => (
                        <div
                            key={title}
                            className="group bg-ink-800 rounded-2xl p-7 border border-ink-700 hover:border-ember-500/50 transition-colors"
                        >
                            <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-fire-gradient shadow-ember-sm mb-5">
                                <Icon className="h-6 w-6 text-white" />
                            </span>
                            <h3 className="font-display text-xl font-bold uppercase tracking-wide text-ink-50 mb-2">
                                {title}
                            </h3>
                            <p className="text-sm text-ink-300 leading-relaxed">
                                {description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
